// Country calling codes for the phone field: [ISO code, calling code, Arabic name, English name].
// Generated from libphonenumber-js. Jordan first, then A–Z in Arabic.
export const PHONE_COUNTRIES: [string, string, string, string][] = [
  ['JO', '962', 'الأردن', 'Jordan'],
  ['IS', '354', 'آيسلندا', 'Iceland'],
  ['ET', '251', 'إثيوبيا', 'Ethiopia'],
  ['AZ', '994', 'أذربيجان', 'Azerbaijan'],
  ['AM', '374', 'أرمينيا', 'Armenia'],
  ['AW', '297', 'أروبا', 'Aruba'],
  ['ER', '291', 'إريتريا', 'Eritrea'],
  ['ES', '34', 'إسبانيا', 'Spain'],
  ['AU', '61', 'أستراليا', 'Australia'],
  ['EE', '372', 'إستونيا', 'Estonia'],
  ['IL', '972', 'إسرائيل', 'Israel'],
  ['SZ', '268', 'إسواتيني', 'Eswatini'],
  ['AF', '93', 'أفغانستان', 'Afghanistan'],
  ['AR', '54', 'الأرجنتين', 'Argentina'],
  ['IO', '246', 'الإقليم البريطاني في المحيط الهندي', 'British Indian Ocean Territory'],
  ['EC', '593', 'الإكوادور', 'Ecuador'],
  ['AE', '971', 'الإمارات العربية المتحدة', 'United Arab Emirates'],
  ['AL', '355', 'ألبانيا', 'Albania'],
  ['BH', '973', 'البحرين', 'Bahrain'],
  ['BR', '55', 'البرازيل', 'Brazil'],
  ['PT', '351', 'البرتغال', 'Portugal'],
  ['BA', '387', 'البوسنة والهرسك', 'Bosnia & Herzegovina'],
  ['CZ', '420', 'التشيك', 'Czechia'],
  ['ME', '382', 'الجبل الأسود', 'Montenegro'],
  ['DZ', '213', 'الجزائر', 'Algeria'],
  ['DK', '45', 'الدانمرك', 'Denmark'],
  ['CV', '238', 'الرأس الأخضر', 'Cape Verde'],
  ['SV', '503', 'السلفادور', 'El Salvador'],
  ['SN', '221', 'السنغال', 'Senegal'],
  ['SD', '249', 'السودان', 'Sudan'],
  ['SE', '46', 'السويد', 'Sweden'],
  ['EH', '212', 'الصحراء الغربية', 'Western Sahara'],
  ['SO', '252', 'الصومال', 'Somalia'],
  ['CN', '86', 'الصين', 'China'],
  ['IQ', '964', 'العراق', 'Iraq'],
  ['GA', '241', 'الغابون', 'Gabon'],
  ['VA', '39', 'الفاتيكان', 'Vatican City'],
  ['PH', '63', 'الفلبين', 'Philippines'],
  ['CM', '237', 'الكاميرون', 'Cameroon'],
  ['CG', '242', 'الكونغو - برازافيل', 'Congo - Brazzaville'],
  ['CD', '243', 'الكونغو - كينشاسا', 'Congo - Kinshasa'],
  ['KW', '965', 'الكويت', 'Kuwait'],
  ['DE', '49', 'ألمانيا', 'Germany'],
  ['MA', '212', 'المغرب', 'Morocco'],
  ['MX', '52', 'المكسيك', 'Mexico'],
  ['SA', '966', 'المملكة العربية السعودية', 'Saudi Arabia'],
  ['GB', '44', 'المملكة المتحدة', 'United Kingdom'],
  ['NO', '47', 'النرويج', 'Norway'],
  ['AT', '43', 'النمسا', 'Austria'],
  ['NE', '227', 'النيجر', 'Niger'],
  ['IN', '91', 'الهند', 'India'],
  ['US', '1', 'الولايات المتحدة', 'United States'],
  ['JP', '81', 'اليابان', 'Japan'],
  ['YE', '967', 'اليمن', 'Yemen'],
  ['GR', '30', 'اليونان', 'Greece'],
  ['AG', '1', 'أنتيغوا وبربودا', 'Antigua & Barbuda'],
  ['AD', '376', 'أندورا', 'Andorra'],
  ['ID', '62', 'إندونيسيا', 'Indonesia'],
  ['AO', '244', 'أنغولا', 'Angola'],
  ['AI', '1', 'أنغويلا', 'Anguilla'],
  ['UY', '598', 'أورغواي', 'Uruguay'],
  ['UZ', '998', 'أوزبكستان', 'Uzbekistan'],
  ['UG', '256', 'أوغندا', 'Uganda'],
  ['UA', '380', 'أوكرانيا', 'Ukraine'],
  ['IR', '98', 'إيران', 'Iran'],
  ['IE', '353', 'أيرلندا', 'Ireland'],
  ['IT', '39', 'إيطاليا', 'Italy'],
  ['PG', '675', 'بابوا غينيا الجديدة', 'Papua New Guinea'],
  ['PY', '595', 'باراغواي', 'Paraguay'],
  ['PK', '92', 'باكستان', 'Pakistan'],
  ['PW', '680', 'بالاو', 'Palau'],
  ['BB', '1', 'بربادوس', 'Barbados'],
  ['BM', '1', 'برمودا', 'Bermuda'],
  ['BN', '673', 'بروناي', 'Brunei'],
  ['BE', '32', 'بلجيكا', 'Belgium'],
  ['BG', '359', 'بلغاريا', 'Bulgaria'],
  ['BZ', '501', 'بليز', 'Belize'],
  ['BD', '880', 'بنغلاديش', 'Bangladesh'],
  ['PA', '507', 'بنما', 'Panama'],
  ['BJ', '229', 'بنين', 'Benin'],
  ['BT', '975', 'بوتان', 'Bhutan'],
  ['BW', '267', 'بوتسوانا', 'Botswana'],
  ['PR', '1', 'بورتوريكو', 'Puerto Rico'],
  ['BF', '226', 'بوركينا فاسو', 'Burkina Faso'],
  ['BI', '257', 'بوروندي', 'Burundi'],
  ['PL', '48', 'بولندا', 'Poland'],
  ['BO', '591', 'بوليفيا', 'Bolivia'],
  ['PF', '689', 'بولينيزيا الفرنسية', 'French Polynesia'],
  ['PE', '51', 'بيرو', 'Peru'],
  ['BY', '375', 'بيلاروس', 'Belarus'],
  ['TH', '66', 'تايلاند', 'Thailand'],
  ['TW', '886', 'تايوان', 'Taiwan'],
  ['TM', '993', 'تركمانستان', 'Turkmenistan'],
  ['TR', '90', 'تركيا', 'Türkiye'],
  ['TA', '290', 'تريستان دا كونا', 'Tristan da Cunha'],
  ['TT', '1', 'ترينيداد وتوباغو', 'Trinidad & Tobago'],
  ['TD', '235', 'تشاد', 'Chad'],
  ['CL', '56', 'تشيلي', 'Chile'],
  ['TZ', '255', 'تنزانيا', 'Tanzania'],
  ['TG', '228', 'توغو', 'Togo'],
  ['TV', '688', 'توفالو', 'Tuvalu'],
  ['TK', '690', 'توكيلاو', 'Tokelau'],
  ['TN', '216', 'تونس', 'Tunisia'],
  ['TO', '676', 'تونغا', 'Tonga'],
  ['TL', '670', 'تيمور - ليشتي', 'Timor-Leste'],
  ['JM', '1', 'جامايكا', 'Jamaica'],
  ['GI', '350', 'جبل طارق', 'Gibraltar'],
  ['AX', '358', 'جزر آلاند', 'Åland Islands'],
  ['BS', '1', 'جزر البهاما', 'Bahamas'],
  ['KM', '269', 'جزر القمر', 'Comoros'],
  ['MQ', '596', 'جزر المارتينيك', 'Martinique'],
  ['MV', '960', 'جزر المالديف', 'Maldives'],
  ['TC', '1', 'جزر توركس وكايكوس', 'Turks & Caicos Islands'],
  ['SB', '677', 'جزر سليمان', 'Solomon Islands'],
  ['FO', '298', 'جزر فارو', 'Faroe Islands'],
  ['FK', '500', 'جزر فوكلاند', 'Falkland Islands'],
  ['VI', '1', 'جزر فيرجن الأمريكية', 'U.S. Virgin Islands'],
  ['VG', '1', 'جزر فيرجن البريطانية', 'British Virgin Islands'],
  ['KY', '1', 'جزر كايمان', 'Cayman Islands'],
  ['CK', '682', 'جزر كوك', 'Cook Islands'],
  ['CC', '61', 'جزر كوكوس (كيلينغ)', 'Cocos (Keeling) Islands'],
  ['MH', '692', 'جزر مارشال', 'Marshall Islands'],
  ['MP', '1', 'جزر ماريانا الشمالية', 'Northern Mariana Islands'],
  ['WF', '681', 'جزر والس وفوتونا', 'Wallis & Futuna'],
  ['AC', '247', 'جزيرة أسينشيون', 'Ascension Island'],
  ['CX', '61', 'جزيرة كريسماس', 'Christmas Island'],
  ['IM', '44', 'جزيرة مان', 'Isle of Man'],
  ['NF', '672', 'جزيرة نورفولك', 'Norfolk Island'],
  ['CF', '236', 'جمهورية أفريقيا الوسطى', 'Central African Republic'],
  ['DO', '1', 'جمهورية الدومينيكان', 'Dominican Republic'],
  ['ZA', '27', 'جنوب أفريقيا', 'South Africa'],
  ['SS', '211', 'جنوب السودان', 'South Sudan'],
  ['GE', '995', 'جورجيا', 'Georgia'],
  ['DJ', '253', 'جيبوتي', 'Djibouti'],
  ['JE', '44', 'جيرسي', 'Jersey'],
  ['DM', '1', 'دومينيكا', 'Dominica'],
  ['RW', '250', 'رواندا', 'Rwanda'],
  ['RU', '7', 'روسيا', 'Russia'],
  ['RO', '40', 'رومانيا', 'Romania'],
  ['RE', '262', 'روينيون', 'Réunion'],
  ['ZM', '260', 'زامبيا', 'Zambia'],
  ['ZW', '263', 'زيمبابوي', 'Zimbabwe'],
  ['CI', '225', 'ساحل العاج', 'Côte d’Ivoire'],
  ['WS', '685', 'ساموا', 'Samoa'],
  ['AS', '1', 'ساموا الأمريكية', 'American Samoa'],
  ['BL', '590', 'سان بارتليمي', 'St. Barthélemy'],
  ['PM', '508', 'سان بيير ومكويلون', 'St. Pierre & Miquelon'],
  ['MF', '590', 'سان مارتن', 'St. Martin'],
  ['SM', '378', 'سان مارينو', 'San Marino'],
  ['VC', '1', 'سانت فنسنت وجزر غرينادين', 'St. Vincent & Grenadines'],
  ['KN', '1', 'سانت كيتس ونيفيس', 'St. Kitts & Nevis'],
  ['LC', '1', 'سانت لوسيا', 'St. Lucia'],
  ['SX', '1', 'سانت مارتن', 'Sint Maarten'],
  ['SH', '290', 'سانت هيلينا', 'St. Helena'],
  ['ST', '239', 'ساو تومي وبرينسيبي', 'São Tomé & Príncipe'],
  ['LK', '94', 'سريلانكا', 'Sri Lanka'],
  ['SJ', '47', 'سفالبارد وجان ماين', 'Svalbard & Jan Mayen'],
  ['SK', '421', 'سلوفاكيا', 'Slovakia'],
  ['SI', '386', 'سلوفينيا', 'Slovenia'],
  ['SG', '65', 'سنغافورة', 'Singapore'],
  ['SY', '963', 'سوريا', 'Syria'],
  ['SR', '597', 'سورينام', 'Suriname'],
  ['CH', '41', 'سويسرا', 'Switzerland'],
  ['SL', '232', 'سيراليون', 'Sierra Leone'],
  ['SC', '248', 'سيشل', 'Seychelles'],
  ['RS', '381', 'صربيا', 'Serbia'],
  ['TJ', '992', 'طاجيكستان', 'Tajikistan'],
  ['OM', '968', 'عُمان', 'Oman'],
  ['GM', '220', 'غامبيا', 'Gambia'],
  ['GH', '233', 'غانا', 'Ghana'],
  ['GD', '1', 'غرينادا', 'Grenada'],
  ['GL', '299', 'غرينلاند', 'Greenland'],
  ['GT', '502', 'غواتيمالا', 'Guatemala'],
  ['GP', '590', 'غوادلوب', 'Guadeloupe'],
  ['GU', '1', 'غوام', 'Guam'],
  ['GF', '594', 'غويانا الفرنسية', 'French Guiana'],
  ['GY', '592', 'غيانا', 'Guyana'],
  ['GG', '44', 'غيرنزي', 'Guernsey'],
  ['GN', '224', 'غينيا', 'Guinea'],
  ['GQ', '240', 'غينيا الاستوائية', 'Equatorial Guinea'],
  ['GW', '245', 'غينيا بيساو', 'Guinea-Bissau'],
  ['VU', '678', 'فانواتو', 'Vanuatu'],
  ['FR', '33', 'فرنسا', 'France'],
  ['PS', '970', 'فلسطين', 'Palestine'],
  ['VE', '58', 'فنزويلا', 'Venezuela'],
  ['FI', '358', 'فنلندا', 'Finland'],
  ['VN', '84', 'فيتنام', 'Vietnam'],
  ['FJ', '679', 'فيجي', 'Fiji'],
  ['CY', '357', 'قبرص', 'Cyprus'],
  ['QA', '974', 'قطر', 'Qatar'],
  ['KG', '996', 'قيرغيزستان', 'Kyrgyzstan'],
  ['KZ', '7', 'كازاخستان', 'Kazakhstan'],
  ['NC', '687', 'كاليدونيا الجديدة', 'New Caledonia'],
  ['HR', '385', 'كرواتيا', 'Croatia'],
  ['KH', '855', 'كمبوديا', 'Cambodia'],
  ['CA', '1', 'كندا', 'Canada'],
  ['CU', '53', 'كوبا', 'Cuba'],
  ['CW', '599', 'كوراساو', 'Curaçao'],
  ['KR', '82', 'كوريا الجنوبية', 'South Korea'],
  ['KP', '850', 'كوريا الشمالية', 'North Korea'],
  ['CR', '506', 'كوستاريكا', 'Costa Rica'],
  ['XK', '383', 'كوسوفو', 'Kosovo'],
  ['CO', '57', 'كولومبيا', 'Colombia'],
  ['KI', '686', 'كيريباتي', 'Kiribati'],
  ['KE', '254', 'كينيا', 'Kenya'],
  ['LV', '371', 'لاتفيا', 'Latvia'],
  ['LA', '856', 'لاوس', 'Laos'],
  ['LB', '961', 'لبنان', 'Lebanon'],
  ['LU', '352', 'لوكسمبورغ', 'Luxembourg'],
  ['LY', '218', 'ليبيا', 'Libya'],
  ['LR', '231', 'ليبيريا', 'Liberia'],
  ['LT', '370', 'ليتوانيا', 'Lithuania'],
  ['LI', '423', 'ليختنشتاين', 'Liechtenstein'],
  ['LS', '266', 'ليسوتو', 'Lesotho'],
  ['MO', '853', 'ماكاو', 'Macao'],
  ['MT', '356', 'مالطا', 'Malta'],
  ['ML', '223', 'مالي', 'Mali'],
  ['MY', '60', 'ماليزيا', 'Malaysia'],
  ['YT', '262', 'مايوت', 'Mayotte'],
  ['MG', '261', 'مدغشقر', 'Madagascar'],
  ['EG', '20', 'مصر', 'Egypt'],
  ['MK', '389', 'مقدونيا الشمالية', 'North Macedonia'],
  ['MW', '265', 'ملاوي', 'Malawi'],
  ['MN', '976', 'منغوليا', 'Mongolia'],
  ['MR', '222', 'موريتانيا', 'Mauritania'],
  ['MU', '230', 'موريشيوس', 'Mauritius'],
  ['MZ', '258', 'موزمبيق', 'Mozambique'],
  ['MD', '373', 'مولدوفا', 'Moldova'],
  ['MC', '377', 'موناكو', 'Monaco'],
  ['MS', '1', 'مونتسرات', 'Montserrat'],
  ['MM', '95', 'ميانمار (بورما)', 'Myanmar (Burma)'],
  ['FM', '691', 'ميكرونيزيا', 'Micronesia'],
  ['NA', '264', 'ناميبيا', 'Namibia'],
  ['NR', '674', 'ناورو', 'Nauru'],
  ['NP', '977', 'نيبال', 'Nepal'],
  ['NG', '234', 'نيجيريا', 'Nigeria'],
  ['NI', '505', 'نيكاراغوا', 'Nicaragua'],
  ['NZ', '64', 'نيوزيلندا', 'New Zealand'],
  ['NU', '683', 'نيوي', 'Niue'],
  ['HT', '509', 'هايتي', 'Haiti'],
  ['HN', '504', 'هندوراس', 'Honduras'],
  ['HU', '36', 'هنغاريا', 'Hungary'],
  ['NL', '31', 'هولندا', 'Netherlands'],
  ['BQ', '599', 'هولندا الكاريبية', 'Caribbean Netherlands'],
  ['HK', '852', 'هونغ كونغ', 'Hong Kong'],
];

